var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sales-page"},[(_vm.salesItems != null)?_c('div',{staticClass:"container"},[(_vm.setup != null)?_c('div',{staticClass:"page-title"},[_c('h1',[_vm._v(_vm._s(_vm.setup.page_titles.sales_title))])]):_vm._e()]):_vm._e(),_c('PromoSales'),_c('formPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }